export const getCurrencySymbol = (languageCode: string, currencyCode: string): string | null => {
  if (!(languageCode && currencyCode)) {
    return null;
  }
  const parts = new Intl.NumberFormat(languageCode, { style: 'currency', currency: currencyCode })?.formatToParts(0);
  const symbol = parts.find(item => item.type === 'currency');

  return symbol.value;
};
